import { Flex, Stack } from '@chakra-ui/react';
import { noop } from 'lodash';
import { memo, useEffect } from 'react';

import CreateGiftCardsForm from '@features/giftCards/CreateGiftCardsForm';
import GiftCardSummary from '@features/giftCards/GiftCardSummary';
import { usePageFormControlsContext } from '@features/navigation/context';

interface Props {
  goBack: () => void;
}
const CreateGiftCardPage = ({ goBack }: Props) => {
  const [_, setShowFormControlsContext] = usePageFormControlsContext();

  useEffect(() => {
    setShowFormControlsContext({
      showFormControls: true,
      onDiscard: goBack,
      onSave: () => {},
    });
    return () => {
      setShowFormControlsContext({
        showFormControls: false,
        onDiscard: noop,
        onSave: noop,
      });
    };
  }, [goBack, setShowFormControlsContext]);

  return (
    <Stack direction={{ base: 'column', xl: 'row' }} py={4}>
      <Flex w={{ base: 'md', xlDown: 'full' }}>
        <GiftCardSummary />
      </Flex>
      <Flex flex={1}>
        <CreateGiftCardsForm />
      </Flex>
    </Stack>
  );
};

export default memo(CreateGiftCardPage);
